import validate from "/builds/escapadarural/rurality-nuxt/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45auth_45admin_45id_45global from "/builds/escapadarural/rurality-nuxt/middleware/01.AuthAdminId.global.ts";
import _02_45auth_45admin_45global from "/builds/escapadarural/rurality-nuxt/middleware/02.AuthAdmin.global.ts";
import _03_45api_45headers_45global from "/builds/escapadarural/rurality-nuxt/middleware/03.ApiHeaders.global.ts";
import _04_45auth_45user_45store_45global from "/builds/escapadarural/rurality-nuxt/middleware/04.AuthUserStore.global.ts";
import _05_45auth_45guard_45global from "/builds/escapadarural/rurality-nuxt/middleware/05.AuthGuard.global.ts";
import _06_45analytics_45global from "/builds/escapadarural/rurality-nuxt/middleware/06.Analytics.global.ts";
import manifest_45route_45rule from "/builds/escapadarural/rurality-nuxt/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _01_45auth_45admin_45id_45global,
  _02_45auth_45admin_45global,
  _03_45api_45headers_45global,
  _04_45auth_45user_45store_45global,
  _05_45auth_45guard_45global,
  _06_45analytics_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}